import React, { Component } from 'react';
import axios from 'axios';
import {
    Card,
    Form,
    Header,
    Icon,
    Image,
    Message,
    Popup,
    Search,
    Segment,
    Grid,
    Embed,
    Input,
    Loader
} from 'semantic-ui-react';
import bgFaq from '../../images/background-opacityTransition4.png';
import { IconHeader } from '../Professor/ProfessorInputGrades/css';
import { Link } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';


class FAQ extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            userType: [],
            question: '',
            answer: '',
            data: [],
            open: false,
            loader: true,
            roleKey: 'studentska',
            openButton: true,
            answerIndex: null
        };

        this.fetchData = this.fetchData.bind(this);
        this.showQuestion = this.showQuestion.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            filterMode: true,
            [name]: value
        });
        let filterData;
        filterData = this.state.data.filter((e) => e.question.toLowerCase().match(value.toLowerCase()));

        this.setState({
            filterData
        });
    }


    componentDidMount() {
        this.fetchData();
    }

    getDataToRender() {
        if (this.state.filterMode) {
            return this.state.filterData;
        }

        return this.state.data;
    }

    fetchData() {
        axios.get('/faq/by-user-type')
            .then(res => {
                this.setState({ data: res.data, loader: false });
            });
    }

    showQuestion() {
        this.setState({ showQuestion: false });
    }

    render() {
        return (
            <div>

                <Header as="h1">Najčešće postavljena pitanja</Header>
                <Segment.Group >
                    <div className="ui fluid image">
                        <Image src={bgFaq} />
                        <div style={{
                            position: 'absolute', top: '40%', width: '100%', height: 'auto', opacity: 0.7
                        }}
                        > <Form><Form.Group widths="3" >
                            <Form.Field width={3} />
                            <Form.Field width={10}>
                                    <Form.Field
                                        required
                                        icon={{ name: 'search', link: true }}
                                        control={Input}
                                        placeholder="Pretraži pitanja..."
                                        name="question"
                                        value={this.state.question}
                                        onChange={this.handleInputChange}
                                />

                                </Form.Field>
                            <Form.Field width={3} />
                        </Form.Group>
                        </Form>
                        </div>
                    </div>
                    <Segment clearing >

                        {this.state.loader ?
                            <Loader active inline="centered" /> :

                            this.getDataToRender().length === 0 ?
                                <p>Ukoliko Vaše pitanje niste pronašli na ponuđenom spisku, možete nam se obratiti putem forme
                                    <Link to="/komentari-i-prijedlozi"> komentari i prijedlozi.</Link>
                                </p>

                                :

                                this.getDataToRender().map((el, index) => (


                                    <Message as={Segment} color={index === this.state.answerIndex ? 'blue' : 'white'} clearing>
                                        <Header
                                            style={{ color: '#1B3D6C', marginLeft: 5 }}
                                            as="h4"
                                            onClick={() => {
                                                this.setState({ answerIndex: index === this.state.answerIndex ? null : index });
                                            }}
                                        >
                                            {el.question}
                                            <Header
                                                style={IconHeader}
                                                floated="right"
                                            >
                                                <Icon />
                                                <Popup
                                                    trigger={<Icon

                                                        link
                                                        circular
                                                        floated="right"
                                                        name={index === this.state.answerIndex ? 'chevron up' : 'chevron down'}
                                                    />}
                                                    content="Prikaži odgovor"
                                                    hideOnScroll
                                                    position="top center"
                                                />
                                            </Header>
                                        </Header>

                                        { index === this.state.answerIndex && <Message.Content style={{
                                            textAlign: 'justify', color: '#1B3D6C', margin: 5, marginTop: 10, lineHeight: 1.6
                                        }}
                                        >
                                            {el.answer}
                                        </Message.Content>}

                                    </Message>

                                )) }

                    </Segment>
                </Segment.Group>
                <ToastContainer />
            </div>
        );
    }
}


export default FAQ;



// WEBPACK FOOTER //
// ./src/views/FAQ/FAQ.js